import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "accented-container" }
const _hoisted_2 = { class: "message-alert" }
const _hoisted_3 = { class: "alert-content d-flex justify-content-between align-items-center" }
const _hoisted_4 = {
  class: "flex-grow-1 text-center",
  "data-testid": "message-alert-content"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 1 }

import { watch, computed } from 'vue';
import { useRouter } from 'vue-router';
import useStickyAlerts from '@/modules/alerts/composables/useStickyAlerts';
import { MessageStickyAlertPropsSchema } from '@/modules/alerts/models/message-sticky-alert-props';
import { STICKY_ALERT_TYPE } from '@/modules/alerts/models/sticky-alert-type';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';


export default /*@__PURE__*/_defineComponent({
  __name: 'WCMessageStickyAlert',
  props: {
    type: {},
    messageSegments: {},
    options: {},
    id: {}
  },
  setup(__props: any) {

const router = useRouter();
const { findAlert, answerAlert, setupTimeout } = useStickyAlerts();

const props = __props;

const alert = findAlert(STICKY_ALERT_TYPE.MESSAGE, props.id);

const close = () => {
  answerAlert(alert, { result: 'DISMISS' });
};

const handleSegmentClick = (link?: string) => {
  if (link) {
    close();
    router.push(link);
  }
};

setupTimeout(STICKY_ALERT_TYPE.MESSAGE, props.id, alert, props.options?.timeoutMs);

if (props.options?.dismissCondition) {
  const shouldDismiss = computed(() => props.options.dismissCondition());

  watch(
    shouldDismiss,
    shouldDismissValue => {
      if (shouldDismissValue && alert) {
        close();
      }
    },
    { immediate: true },
  );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "accent" }, null, -1)),
    _cache[2] || (_cache[2] = _createTextVNode()),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.messageSegments, (segment, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (segment.link)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "link-segment underline-link-from-center",
                    onClick: ($event: any) => (handleSegmentClick(segment.link))
                  }, _toDisplayString(segment.text), 9, _hoisted_5))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(segment.text), 1))
            ], 64))
          }), 128))
        ]),
        _cache[0] || (_cache[0] = _createTextVNode()),
        _createElementVNode("span", {
          class: "cursor-pointer ml-2",
          onClick: _withModifiers(close, ["stop"]),
          "data-testid": "notification-alert-close-button"
        }, [
          _createVNode(_unref(FontAwesomeIcon), {
            icon: "xmark",
            size: "lg",
            class: "close-icon"
          })
        ])
      ])
    ])
  ]))
}
}

})